oyc.Sharing = {
  selector: {
    container: '.share-wrap',
    shariffContainer: '.shariff',
  },
  container: null,
  shariff: null,
  init: function () {
    this.container = document.querySelector(this.selector.container);
    if (this.container) {
      this.addShariffIcons();
    }
  },
  addShariffIcons: function () {
    this.shariff = document.querySelector(this.selector.shariffContainer);
    let shariffLinks = this.shariff.querySelectorAll('.shariff-button a');
    for (let i = 0, len = shariffLinks.length; i < len; i++) {
      const item = shariffLinks[i];
      item.innerHTML = '';
      const networkClass = item.parentElement.className.replace('shariff-button ', ''),
        networkItem = this.shariff.querySelector('[class*="fa-' + networkClass + '"]');
      if (networkItem) {
        item.appendChild(networkItem);
      }
    }
  }
}
